import '../../../../../Framework/assets/vendors/amcharts5/index';
import '../../../../../Framework/assets/vendors/amcharts5/xy';
import '../../../../../Framework/assets/vendors/amcharts5/percent';
import '../../../../../Framework/assets/vendors/amcharts5/themes/Animated.js';
import '../../../../../Framework/assets/vendors/amcharts5/locales/lt_LT.js';

/**
 * Sukuria ir atvaizduoja XY (stulpelinę) diagramą.
 * @param {string} chartDivId - HTML elemento ID, kuriame piešti diagramą.
 * @param {Array} data - Duomenų masyvas diagramai.
 * @param {Array} response - Duomenų masyvas
 */
function renderXYChart(chartDivId, data, response) {
    let root = am5.Root.new(chartDivId);
    root.setThemes([am5themes_Animated.new(root)]);
    const textColor = applyChartTextColor(root);


    //Mobile sutvarkyti, kad nebūtų sugrūsta, kai daug stulpelių
    if (isMobile && data.length > 12) {
        const valueFields = response.series && response.series.length
            ? response.series.map(s => s.value_field)
            : [response.value_field];

        data = [...data]
            .sort((a, b) => {
                const sumA = valueFields.reduce((sum, field) => sum + Number(a[field] || 0), 0);
                const sumB = valueFields.reduce((sum, field) => sum + Number(b[field] || 0), 0);

                return sumB - sumA;
            })
            .slice(0, 12);
    }

    let chart = root.container.children.push(am5xy.XYChart.new(root, {
        //text: response.name,
        panX: false,
        panY: false,
        wheelX: 'panX',
        //wheelY: 'zoomX',
        layout: isMobile ? root.verticalLayout : root.horizontalLayout,
        paddingLeft: isMobile ? 0 : 20,
        paddingRight: isMobile ? 0 : 20,
        paddingTop: 10,
        paddingBottom: 10,
    }));

    let cursor = chart.set('cursor', am5xy.XYCursor.new(root, {}));
    cursor.lineY.set('visible', false);

    // X axis

    let xRenderer = am5xy.AxisRendererX.new(root, {
        minGridDistance: 0,// padidinam atstumą tarp X ašies label'ių
    });
    xRenderer.setAll({
        minGridDistance: 0,
        cellStartLocation: 0.3,
        cellEndLocation: 0.7,
    });

    let xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
        categoryField: response.category_field,
        renderer: xRenderer,
        tooltip: am5.Tooltip.new(root, {}),
    }));

    //ČIA vyksta pasukimas
    xRenderer.labels.template.setAll({
        rotation: -90,        // gali bandyti -60 arba -90
        centerY: am5.p50,
        centerX: am5.p100,
        oversizedBehavior: 'wrap',   // jei labai ilgi – leis laužyti tekstą
        maxWidth: 120,
    });

    xAxis.data.setAll(data);

    // Y axis
    let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
        min: 0,
        strictMinMax: false,
        renderer: am5xy.AxisRendererY.new(root, {}),
        //treatZeroAs: 0.001,
        maxPrecision: 0,
    }));

    var addSeries = function(series) {
        series.columns.template.setAll({
            width: am5.percent(100),
            maxWidth: 100,//maksimalus plotis pikseliais
            cornerRadiusTL: 2,
            cornerRadiusTR: 2,
        });
        //series.bullets.push(function () {
        //    return am5.Bullet.new(root, {
        //        locationY: 1, //viršuje reikšmė virš stulpelį
        //        sprite: am5.Label.new(root, {
        //            text: "{valueY}",
        //            centerX: am5.p50,
        //            centerY: am5.p100,
        //            populateText: true,
        //            fontSize: 12,//virš stulpelio reikšmė
        //        })
        //    });
        //});
    }

    let legend = null;
    if (response.series && response.series.length) {
        // ==================================================
        // 1) CLUSTERED CHART (kelios serijos)
        // ==================================================

        // Legend (rodoma tik jei yra kelios serijos)
        legend = am5.Legend.new(root, {
            layout: root.verticalLayout,
            width: isMobile ? am5.percent(100) : undefined,

            x: isMobile ? 0 : am5.p100,
            centerX: isMobile ? 0 : am5.p100,

            y: isMobile ? 0 : am5.p50,
            centerY: isMobile ? 0 : am5.p50,

            paddingTop: isMobile ? 5 : 0,
            paddingBottom: 0,
            paddingLeft: 10,
            paddingRight: 10,
        });

        legend.labels.template.setAll({
            oversizedBehavior: "wrap",
            maxWidth: isMobile ? 130 : 160,
            fontSize: isMobile ? 11 : 14,
        });

        legend.markers.template.setAll({
            width: isMobile ? 12 : 16,
            height: isMobile ? 12 : 16,
        });

        if (!isMobile) {
            chart.children.push(legend);
        }

        // Perkeliame legendą į dešinę pusę
        //chart.children.moveValue(legend);

        response.series.forEach(seriesConfig => {
            let series = chart.series.push(am5xy.ColumnSeries.new(root, {
                //name: seriesConfig.name,
                name: `${seriesConfig.name} ${seriesConfig.total ?? 0}`,
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: seriesConfig.value_field,
                categoryXField: response.category_field,
                tooltip: am5.Tooltip.new(root, {
                    labelText: `{${response.category_field}}: {valueY}`,
                }),
            }));

            // ✅ Spalvos serijai (CLUSTERED)
            if (seriesConfig.color) {
                const c = am5.color(seriesConfig.color);

                // serijos spalva (legend/tooltip marker)
                series.setAll({ fill: c, stroke: c });

                // stulpelių spalva
                series.columns.template.setAll({ fill: c, stroke: c });
            }

            addSeries(series);

            series.data.setAll(data);
            legend.data.push(series);
        });

    } else {
        // ==================================================
        // 2) PAPRASTAS XY (viena serija)
        // ==================================================

        let series = chart.series.push(am5xy.ColumnSeries.new(root, {
            name: response.name,
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: response.value_field,
            categoryXField: response.category_field,
            tooltip: am5.Tooltip.new(root, {
                labelText: `{${response.category_field}}: {valueY}`,
            }),
        }));
        addSeries(series);


        //region color gradient
        const startColor = (response.theme.start_color || "#082D44").trim();
        const endColor = (response.theme.end_color || "#EAF1F4").trim();

        // sugeneruojam tiek spalvų, kiek kategorijų
        const gradientColors = makeGradient(startColor, endColor, data.length);

        series.columns.template.adapters.add("fill", (fill, target) => {
            const idx = series.columns.indexOf(target);
            return am5.color(gradientColors[idx]) ?? fill;
        });
        series.columns.template.adapters.add("stroke", (stroke, target) => {
            const idx = series.columns.indexOf(target);
            return am5.color(gradientColors[idx]) ?? stroke;
        });
        //endregion color gradient

        series.data.setAll(data);
    }

    chart.appear(1000, 100);


    var translationTotal = $('[data-l10n-total]').attr('data-l10n-total')
    if (isMobile && legend) {
        const footer = chart.children.push(
            am5.Container.new(root, {
                width: am5.percent(100),
                layout: root.verticalLayout,
                x: 0,
                y: am5.p100,
                centerY: am5.p100,
                paddingTop: 5,
            })
        );

        footer.children.push(
            am5.Label.new(root, {
                text: translationTotal + ' ' + response.total,
                fontSize: 12,
                fontWeight: '600',
                width: am5.percent(100),
                textAlign: 'right',
                paddingRight: 10,
                paddingBottom: 5,
            })
        );

        footer.children.push(legend);
    } else {
        // Desktop paliekam kaip buvo
        chart.children.push(
            am5.Label.new(root, {
                text: translationTotal + ' ' + response.total,
                fontSize: 14,
                fontWeight: '600',
                x: am5.p100,
                centerX: am5.p100,
                y: am5.p100,
                centerY: am5.p100,
                paddingTop: 6,
                paddingBottom: 6,
                paddingLeft: 10,
                paddingRight: 10,
            })
        );
    }
}

/**
 * Sukuria ir atvaizduoja Pie (skritulinę) diagramą.
 * @param {string} chartDivId - HTML elemento ID, kuriame piešti diagramą.
 * @param {Array} data - Duomenų masyvas diagramai.
 * @param {Array} response - Duomenų masyvas
 */
function renderPieChart(chartDivId, data, response) {
    var root = am5.Root.new(chartDivId);
    root.setThemes([am5themes_Animated.new(root)]);
    const textColor = applyChartTextColor(root);

    let chart = root.container.children.push(am5percent.PieChart.new(root, {
        layout: isMobile ? root.verticalLayout : root.horizontalLayout,
        paddingLeft: isMobile ? 0 : 20,
        paddingRight: isMobile ? 0 : 20,
        paddingTop: 10,
        paddingBottom: 10
    }));

    let series = chart.series.push(am5percent.PieSeries.new(root, {
        name: response.name,
        valueField: response.value_field,
        categoryField: response.category_field,
        alignLabels: true,
        tooltip: am5.Tooltip.new(root, {
            labelText: "{category}: {value} ({valuePercentTotal.formatNumber('#.')}%)"
        })
    }));

    //spalvos
    series.slices.template.adapters.add("fill", (fill, target) => {
        const ctx = target.dataItem?.dataContext;
        const c = ctx?.color;
        return c ? am5.color(c) : fill;
    });
    series.slices.template.adapters.add("stroke", (stroke, target) => {
        const ctx = target.dataItem?.dataContext;
        const c = ctx?.color;
        return c ? am5.color(c) : stroke;
    });

    // sumažinam skritulį, kad liktų vietos tekstui
    series.set("radius", am5.percent(isMobile ? 80 : 70));


    // labelių nustatymai prie rodyklyčių
    series.labels.template.setAll({
        oversizedBehavior: "wrap", //none/hide/fit/wrap/wrap-no-break/truncate
        maxWidth: 120,
        //text: "{category}: {valuePercentTotal.formatNumber('#.00')}%",
        text: "{value} ({valuePercentTotal.formatNumber('#.')}%)",
        fontSize: 12
    });


    //region slėpti labai mažų slice’ų labelius

    if (isMobile) {
        series.labels.template.set("forceHidden", true);
        series.ticks.template.set("forceHidden", true);
    } else {
        series.labels.template.adapters.add("forceHidden", function (_hidden, target) {
            const dataItem = target.dataItem;
            if (!dataItem) return false;

            const percent = dataItem.get("valuePercentTotal");
            return percent < 3;
        });
        series.ticks.template.adapters.add("forceHidden", function (_hidden, target) {
            const dataItem = target.dataItem;
            if (!dataItem) return false;

            const percent = dataItem.get("valuePercentTotal");
            return percent < 3;
        });

        // ticks irgi truputį trumpesni
        series.ticks.template.setAll({
            forceHidden: false,
            strokeOpacity: 0.3,
        });
    }
    //endregion




    // spalvos iš PHP
    data = data.map(item => ({
        ...item,
        sliceSettings: {
            fill: am5.color(item.color || '#cccccc')
        }
    }));

    series.slices.template.setAll({
        //stroke: am5.color(0xffffff), // arba null
        strokeWidth: 0,
    });

    series.data.setAll(data);
    series.appear(1000, 100);

    let legend = chart.children.push(am5.Legend.new(root, {
        nameField: "categoryX",
        layout:root.verticalLayout,
        x: isMobile ? am5.p50 : am5.p100,
        centerX: isMobile ? am5.p50 : am5.p100,
        y: isMobile ? undefined : am5.p50,
        centerY: isMobile ? undefined : am5.p50,
    }));
    legend.labels.template.setAll({
        oversizedBehavior: "wrap",
        maxWidth: isMobile ? 120 : 150,
        fontSize: isMobile ? 12 : 14,
    });
    legend.data.setAll(series.dataItems);
    //Slėpti procentus prie legendos
    legend.valueLabels.template.set("forceHidden", true);

    //"Viso:"
    var translationTotal = $('[data-l10n-total]').attr('data-l10n-total');
    chart.children.push(
        am5.Label.new(root, {
            text: translationTotal + ' ' + response.total,
            fontSize: 14,
            fontWeight: '600',
            marginTop: 10,
            x: am5.p100,
            centerX: am5.p100,
            y: am5.p100,
            centerY: am5.p100,
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 10
        })
    );
}

const chartRenderers = {
    'xy': renderXYChart,
    'pie': renderPieChart,
};

//region color gradient
function hexToRgb(hex) {
    hex = hex.replace('#', '');
    return {
        r: parseInt(hex.substring(0, 2), 16),
        g: parseInt(hex.substring(2, 4), 16),
        b: parseInt(hex.substring(4, 6), 16)
    };
}

function rgbToHex(r, g, b) {
    return "#" + [r, g, b]
        .map(x => x.toString(16).padStart(2, '0'))
        .join('');
}

function interpolateColor(color1, color2, factor) {
    const c1 = hexToRgb(color1);
    const c2 = hexToRgb(color2);

    return rgbToHex(
        Math.round(c1.r + (c2.r - c1.r) * factor),
        Math.round(c1.g + (c2.g - c1.g) * factor),
        Math.round(c1.b + (c2.b - c1.b) * factor)
    );
}

function makeGradient(startColor, endColor, steps) {
    const colors = [];

    for (let i = 0; i < steps; i++) {
        const factor = i / (steps - 1);
        colors.push(interpolateColor(startColor, endColor, factor));
    }

    return colors;
}
//endregion color gradient

/**
 * Įkelia visas diagramas nurodytoje eilutėje (row).
 * @param {jQuery} rowElement - Eilutės jQuery objektas.
 */
function loadChartsForRow(rowElement) {
    var dataPost = {}
    rowElement.find('input, select, textarea').each(function () {
        const $el = $(this);
        const name = $el.attr('name');

        if (!name) return; // jei nėra name – praleidžiam

        // Checkbox
        if ($el.is(':checkbox')) {
            dataPost[name] = $el.is(':checked') ? $el.val() : null;
            return;
        }

        // Radio
        if ($el.is(':radio')) {
            if ($el.is(':checked')) {
                dataPost[name] = $el.val();
            }
            return;
        }

        // Visi kiti (input, select, textarea)
        dataPost[name] = $el.val();
    });

    rowElement.find('.card-body[data-statistics-api-url]').each(function () {
        const cardBody = $(this);
        const url = cardBody.attr('data-statistics-api-url');

        $.post({
            url: url,
            //method: 'POST',
            //datatype: 'json',//xml, json, script, text, html
            //async: false,
            data: dataPost,
            beforeSend: function (jqXHR, settings) {
                cardBody.find('> .charplace .am-chart').hide();
                cardBody.find('> .charplace .spinner-border').show();
                cardBody.find('> [data-error-place]').hide();
            },
            success: function (response, textStatus, jqXHR) {
                cardBody.find('.spinner-border').hide();
                cardBody.find('> .charplace .spinner-border').hide();

                var chartDiv = cardBody.find('.am-chart');

                if (!chartDiv.length) return; // Saugiklis, jei nėra diagramos elemento

                var chartDivId = chartDiv.attr('id');

                // =================================================================
                if (response && response.chart_type && response.chart_data) {

                    cardBody.find('[data-title]').html(response.name);
                    if (response.chart_data.length) {
                        const renderer = chartRenderers[response.chart_type];
                        if (renderer) {
                            var minHeight = '450px';
                            if (response.chart_type === 'pie') {
                                if (response.chart_data.length >= 6) {
                                    var minHeight = '600px';
                                }
                            }
                            cardBody.find('> .charplace .am-chart').css('min-height', minHeight).show();
                            // Svarbu: sunaikiname seną diagramą, jei ji egzistuoja
                            if (am5.registry.rootElements && am5.registry.rootElements.length) {
                                am5.registry.rootElements.forEach(function(root) {
                                    if (root?.dom?.id === chartDivId) {
                                        root.dispose();
                                    }
                                });
                            }

                            // Iškviečiame tinkamą funkciją pagal gautą tipą
                            renderer(chartDivId, response.chart_data, response);
                        } else {
                            console.error('Nėra žinomas diagramos tipas:', response.chart_type);
                            cardBody.find('[data-error-place]').html(`<i class="fa-solid fa-triangle-exclamation"></i> Klaida: nežinomas diagramos tipas.`).show();
                        }
                    } else {
                        var noDataTranslation = $('[data-l10n-no-data]').attr('data-l10n-no-data')
                        cardBody.find('[data-error-place]').html(`<i class="fa-solid fa-triangle-exclamation"></i> ${noDataTranslation}.`).show();
                    }
                } else {
                    var noDataTranslation = $('[data-l10n-no-data]').attr('data-l10n-no-data')
                    cardBody.find('[data-error-place]').html(`<i class="fa-solid fa-triangle-exclamation"></i> ${noDataTranslation}.`).show();
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                cardBody.find('> .charplace .spinner-border').hide();
                console.error(jqXHR, textStatus, errorThrown);
                try {
                    var error = $.parseJSON(jqXHR.responseText).error
                } catch (e) {
                    //not json
                    var error = textStatus
                }
                cardBody.find('> :not(.charplace)').html(`<i class="fa-solid fa-triangle-exclamation"></i> ${error}`);
                cardBody.find('> .charplace').hide();
            },
            //complete: function (jqXHR, textStatus) {}
        });
    });
}


const isMobile = window.innerWidth < 768;

// Pradinių kortelių duomenų (be diagramų) įkėlimas
$('.card[data-statistics-api-url]').each(function () {
    const card = $(this);
    const url = card.attr('data-statistics-api-url');

    $.post({
        url: url,
        success: function (data) {
            card.find('.value').text(data.count);
            if (data.this_year) {
                if (data.this_year.percent == 0) {
                    //card.find('span.badge').hide();
                } else {
                    card.find('span.badge').show();
                    card.find('span.badge').text(data.this_year.percent_text);
                    if (data.this_year.class) {
                        card.find('span.badge').addClass(data.this_year.class);
                    }
                }
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            console.error(jqXHR, textStatus, errorThrown);
            var cardBody = card.find('.card-body');
            cardBody.html(`<i class="fa-solid fa-triangle-exclamation"></i> ${textStatus}`);
        },
        //complete: function (jqXHR, textStatus) {}
    });
});

// Mygtuko paspaudimo apdorojimas
$('.card button[data-load-graph]').on('click', function (e) {
    const row = $(e.currentTarget).closest('.row');
    loadChartsForRow(row);

    setExportValues();
});

// Diagramų įkėlimas užsikrovus puslapiui
$(document).ready(function () {
    // Surandame visas eilutes, kuriose yra diagramų, ir iškviečiame joms įkėlimo funkciją
    $('.card button[data-load-graph]').each(function() {
        const row = $(this).closest('.row');
        loadChartsForRow(row);
    });

    setExportValues();
});
//$('.downloadDropdown').on('click', function (e) {
//    console.log($(this));
//    e.preventDefault();
//});

function setExportValues() {
    $('form.downloadDropdown input[name="graph[1]"]').val($('[data-graphs="1"]').find('select').val())
    $('form.downloadDropdown input[name="graph[2]"]').val($('[data-graphs="2"]').find('select').val())
    $('form.downloadDropdown input[name="graph[3][year_from]"]').val($('[data-graphs="3"]').find('select#year_from').val())
    $('form.downloadDropdown input[name="graph[3][year_to]"]').val($('[data-graphs="3"]').find('select#year_to').val())
}


//region color mode
function getPreferredColorScheme() {
    if (window.matchMedia) {
        if(window.matchMedia('(prefers-color-scheme: dark)').matches){
            return 'dark';
        } else {
            return 'light';
        }
    }
    return 'light';
}

function updateColorScheme(){
    $('html').attr('data-bs-theme', getPreferredColorScheme())

    // Pergeneruoti visus grafikus, kad atitiktų naują spalvų schemą
    $('.card button[data-load-graph]').each(function() {
        const row = $(this).closest('.row');
        // Tikrinama ar grafikai jau buvo užkrauti (ar yra am5 root elementų)
        const hasCharts = row.find('.am-chart').toArray().some(function(chartDiv) {
            return am5.registry.rootElements.some(function(root) {
                return root?.dom?.id === chartDiv.id;
            });
        });

        if (hasCharts) {
            loadChartsForRow(row);
        }
    });
}

if(window.matchMedia){
    var colorSchemeQuery = window.matchMedia('(prefers-color-scheme: dark)');
    colorSchemeQuery.addEventListener('change', updateColorScheme);
}

updateColorScheme();

function isDarkMode() {
    const html = document.documentElement;
    const body = document.body;

    const explicitTheme = html.getAttribute('data-bs-theme')
        || body?.getAttribute('data-bs-theme')
        || html.getAttribute('data-theme')
        || body?.getAttribute('data-theme');

    let darkMode;

    if (explicitTheme) {
        darkMode = explicitTheme === 'dark';
    } else {
        darkMode = html.classList.contains('dark')
            || html.classList.contains('dark-mode')
            || body?.classList.contains('dark')
            || body?.classList.contains('dark-mode')
            || window.matchMedia?.('(prefers-color-scheme: dark)').matches;
    }

    return darkMode;
}
function applyChartTextColor(root) {
    const textColor = am5.color(isDarkMode() ? 0xffffff : 0x000000);

    root.interfaceColors.set('text', textColor);

    return textColor;
}
//endregion color mode
